import React, { useId } from 'react';
import { StyledControlPanel, StyledCarousel, StyledHeadline, StyledCopy, StyledSlideContainer, StyledImage, StyledSlide, StyledTextSlide } from './index.styles.js';
import { Pagination } from '../index.js';
import {} from '@oneaudi/unified-web-common';
import { pickDataProps } from '../../utils/pick-data-props.js';
const isItemsWithPagination = (items) => {
    return (!!items &&
        typeof items === 'object' &&
        !Array.isArray(items) &&
        'incrementElement' in items &&
        'decrementElement' in items &&
        Array.isArray(items.items));
};
const isValidCurrent = (current, items, loop) => {
    const totalItems = isItemsWithPagination(items)
        ? items.items.length
        : items.length;
    if (totalItems === 0) {
        return 1; // Default to 1 if no items exist
    }
    if (loop) {
        if (current < 1) {
            return totalItems; // Wrap around to the last item
        }
        if (current > totalItems) {
            return 1; // Wrap around to the first item
        }
    }
    else {
        if (current < 1) {
            return 1; // Clamp to the first item
        }
        if (current > totalItems) {
            return totalItems; // Clamp to the last item
        }
    }
    return current; // Return valid number
};
export const Carousel = ({ items, variant = 'horizontal', current = 1, loop, margin, ariaCarouselLabel = 'carousel', ariaLiveRegionText = (current, total) => `Slide ${current} of ${total}`, ariaSlideLabel = (index, total, alt) => `Slide ${index + 1} of ${total}${alt ? `, ${alt}` : ''}`, ariaControlsLabel = 'Carousel controls', ariaSlideRoleDescription = 'slide', className, ...rest }) => {
    const id = useId();
    const validCurrent = isValidCurrent(current, items, loop);
    const totalItems = isItemsWithPagination(items)
        ? items.items.length
        : items.length;
    return (React.createElement(StyledCarousel, { variant: variant, margin: margin, role: "region", "aria-label": ariaCarouselLabel, id: id, className: className, ...pickDataProps(rest) },
        React.createElement("div", { "aria-live": "polite", style: { position: 'absolute', left: '-9999px' } }, ariaLiveRegionText(validCurrent, totalItems)),
        React.createElement(StyledSlideContainer, null, (isItemsWithPagination(items) ? items.items : items).map((item, index) => (React.createElement(StyledSlide, { variant: variant, key: index, current: validCurrent, index: index, tabIndex: index === validCurrent - 1 ? 0 : -1, "aria-hidden": index !== validCurrent - 1, role: "group", "aria-roledescription": ariaSlideRoleDescription, "aria-label": ariaSlideLabel(index, totalItems, item.alt) },
            React.createElement(StyledImage, { src: item.src, alt: item.alt }))))),
        React.createElement(StyledControlPanel, { variant: variant, pagination: isItemsWithPagination(items), "aria-controls": id, role: "navigation", "aria-label": ariaControlsLabel },
            isItemsWithPagination(items) && (React.createElement(Pagination, { current: current, decrementElement: {
                    'aria-label': items.decrementElement['aria-label'],
                    onClick: items.decrementElement.onClick
                }, incrementElement: {
                    'aria-label': items.incrementElement['aria-label'],
                    onClick: items.incrementElement.onClick
                }, itemCount: items.items.length, items: items.items, variant: "normal", arrowsAlwaysEnabled: !!loop })),
            React.createElement(StyledSlideContainer, null, (isItemsWithPagination(items) ? items.items : items).map((item, index) => (React.createElement(StyledTextSlide, { current: validCurrent, index: index, key: index, "aria-hidden": index !== validCurrent - 1 },
                item.headline && (React.createElement(StyledHeadline, { key: index, as: item.headline.tag }, item.headline.text)),
                item?.copy && React.createElement(StyledCopy, null, item.copy))))))));
};
Carousel.displayName = 'Carousel';
//# sourceMappingURL=index.js.map